// Minimal ringtone player. Loops an <audio> element until `stop()` is called.
// We keep audio playback fault-tolerant: browsers may block .play() before
// the user has interacted with the page (autoplay policy). We catch the
// rejection and stay silent — the banner is still visible/animated, so the
// agent isn't oblivious; sound is a nice-to-have on top of the visual ring.

type Ring = 'incoming' | 'ringback';

const SOURCES: Record<Ring, string> = {
  incoming: '/rings/ring-02.mp3',
  ringback: '/rings/ring-03.mp3',
};

const players = new Map<Ring, HTMLAudioElement>();

function get(ring: Ring): HTMLAudioElement {
  let el = players.get(ring);
  if (el) return el;
  el = new Audio(SOURCES[ring]);
  el.loop = true;
  el.preload = 'auto';
  // Slightly lower than full so concurrent UI tones don't clip.
  el.volume = 0.7;
  players.set(ring, el);
  return el;
}

export function playRingtone(ring: Ring): void {
  const el = get(ring);
  // Restart from the top so each ring starts clean.
  el.currentTime = 0;
  el.play().catch(() => {
    /* Autoplay blocked — UI ring still visible. */
  });
}

export function stopRingtone(ring: Ring): void {
  const el = players.get(ring);
  if (!el) return;
  el.pause();
  el.currentTime = 0;
}

export function stopAllRingtones(): void {
  for (const el of players.values()) {
    el.pause();
    el.currentTime = 0;
  }
}
